import { SET_CONFIG } from "../actions/actionTypes";

export default function configReducer(state = { env: "dev" }, action) {
    switch (action.type) {
        case SET_CONFIG:
            return { ...state, ...action.value };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/configReducer.js